export default "__VITE_ASSET__C_iP0qAi__"